import React, {useCallback, useEffect, useState} from "react";
import {NavLink, useHistory, useParams} from "react-router-dom";
import useLoader from "../../../hooks/useLoader";
import {Button, Checkbox, CircularProgress, Grid} from "@mui/material";
import DashboardLayout from "../../../layouts/Dashboard"
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import {useDispatch} from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import {DEPARTMENT_DETAIL_ROUTE, DEPARTMENT_LIST_ROUTE, FORM_MAP_LIST_ROUTE} from "../../../routes";
import {departmentCRUD} from "../../../http";
import TextField from "@mui/material/TextField";

const DepartmentDetailForm = () => {
    const history = useHistory()
    const {id} = useParams();
    const [isNew,setIsNew] = useState(id==="new")
    const dispatch = useDispatch()
    const [fields, setFields] = useState({})
    const {loading, start, stop} = useLoader(false)
    const fetch = useCallback(() => {
        start()
        if(!isNew){
            departmentCRUD.get(id).then(data => {
                setFields(state=>{
                    return {
                        ...state,
                        name:data.name || null,
                        description:data.description || null,
                        completeWithoutProtocol: data.completeWithoutProtocol || false
                    }

                })
                stop()
            })
        }else{
            stop()
        }

    }, [dispatch, id])

    useEffect(fetch, [fetch])
    const submit = useCallback(() => {
        if (!isNew){
            departmentCRUD.edit({
                id:id,
                ...fields
            }).catch(err=>{
                alert(err)
            })
        }else{
            departmentCRUD.create({
                ...fields
            }).catch(err=>{
                alert(err)
            }).then((resp)=>{setIsNew(false);history.push(DEPARTMENT_DETAIL_ROUTE(resp.id))})
        }


    }, [id, dispatch, fields])
    const deleteForm = useCallback(()=>{
        departmentCRUD.delete(id).then(()=>{
            history.push(FORM_MAP_LIST_ROUTE)
        }).catch(err=>{
            alert(err)
        })
    },[id])
    return (
        <DashboardLayout>
            {loading ? <CircularProgress/> : <>
                <Grid item xs={12}>
                    <Paper>
                        <Toolbar style={{display:"flex", justifyContent:"space-between"}}>
                            <Typography id="modal-modal-title" variant="h5" component="h2">
                                {isNew?"Создание":"Редактирование"} Лаборатории<br/>
                            </Typography>
                            <div>
                            {!isNew &&
                                <Button onClick={()=>{deleteForm()}} style={{background:"#ff4343", marginRight: "20px"}}>
                                    Удалить
                                </Button>}
                                <NavLink style={{color: '#2f9e69'}} to={DEPARTMENT_LIST_ROUTE}><span
                                    style={{color: "2f9e69"}}>Вернуться к таблице</span></NavLink>
                            </div>
                        </Toolbar>
                    </Paper>
                </Grid>
                <Grid item xs={12} spacing={1} style={{paddingTop: 16}}>
                    <Paper style={{paddingBottom: 20}}>

                        <Grid container xs={12} style={{paddingLeft: 20, paddingRight: 20}}>
                            <Grid item xs={12}>
                                    <TextField required margin="normal"
                                               fullWidth id="personnelNumber" name="personnelNumber" label="Название"
                                               onChange={(ev) => {
                                                   setFields((state) => {
                                                       return {
                                                           ...state,
                                                           name: ev.target.value
                                                       }
                                                   })
                                               }}
                                               value={fields.name || ""}
                                    />
                                </Grid>
                            <Grid item xs={12}>
                                <TextField required margin="normal"
                                           fullWidth id="personnelNumber" name="personnelNumber" label="Описание"
                                           onChange={(ev) => {
                                               setFields((state) => {
                                                   return {
                                                       ...state,
                                                       description: ev.target.value
                                                   }
                                               })
                                           }}
                                           value={fields.description || ""}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Checkbox
                                    id="completeWithoutProtocol"
                                    name="completeWithoutProtocol"
                                    style={{background: "#F8F8F8", borderRadius: "15px"}}                                    
                                    checked={fields.completeWithoutProtocol}                                    
                                    onChange={(e) => {
                                        setFields((state) => {                                            
                                            return {
                                                ...state,
                                                completeWithoutProtocol: e.target.checked
                                            }
                                        })
                                    }}                                    
                                    >                                    
                                </Checkbox>
                                <span>Завершение без протокола</span>
                            </Grid>
                            <Grid item xs={12}>
                                <Checkbox
                                    id="isDeleted"
                                    name="isDeleted"
                                    style={{background: "#F8F8F8", borderRadius: "15px"}}                                    
                                    checked={fields.isDeleted}                                    
                                    onChange={(e) => {
                                        setFields((state) => {                                            
                                            return {
                                                ...state,
                                                isDeleted: e.target.checked
                                            }
                                        })
                                    }}                                    
                                    >                                    
                                </Checkbox>
                                <span>Удален</span>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <LoadingButton style={{marginTop: "10px"}} variant="contained" onClick={() => {
                    submit()
                }}>
                    Сохранить
                </LoadingButton>
            </>}


        </DashboardLayout>
    )
}

export default DepartmentDetailForm